import { render } from "./detail.vue?vue&type=template&id=1a444811&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=tsx"
export * from "./detail.vue?vue&type=script&lang=tsx"

import "./detail.vue?vue&type=style&index=0&id=1a444811&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a444811"]])

export default __exports__